module.exports = __webpack_public_path__ + "img/my request.77ece529.svg";